import { render, staticRenderFns } from "./TwoFactorSettingsModal.vue?vue&type=template&id=c6cedd60&scoped=true"
import script from "./TwoFactorSettingsModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorSettingsModal.vue?vue&type=style&index=0&id=c6cedd60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cedd60",
  null
  
)

export default component.exports